/* eslint import/prefer-default-export: "off" */
import * as React from 'react'
import generateDetailsLink from '@src/utils/generate.details.link'
import Expander from '@src/components/common/expander'
import ExpanderPoliciesContainer from '@src/components/common/expander.policies'
import JsonViewer, { Field } from '@src/components/common/json.viewer'
import styles from '../public.objects.styl'
import type { History } from 'history'
import { ColumnProps, ColumnType } from '@src/components/data.grid'
import { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
import type { PublicObject } from '@src/redux/reducers/external.lists/default.state'

export interface GetColumns {
  history: History
  selectedType: ResourceTypeEnum
}

const getColumns = ({
  history,
  selectedType
}: GetColumns): ColumnProps<PublicObject>[] => [
  { type: ColumnType.selector },
  {
    field: 'name',
    title: 'Name',
    onClick: item => {
      const url = generateDetailsLink(item.uri)
      history.push(url)
    }
  },
  {
    field: 'account_name',
    title: 'Source'
  },
  {
    field: 'region',
    title: 'Region'
  },
  {
    field: 'tag_info',
    title: 'Tags',
    expander: true,
    expanderOptions: {
      expanderTemplate: data => {
        const { original, isExpanded } = data
        const { tag_info } = original
        if (!tag_info || tag_info.length === 0) return null
        return <Expander isExpanded={!!isExpanded}>{tag_info.length}</Expander>
      },
      contentTemplate: (row, column) => {
        const { original } = row
        const { tag_info = [] } = original
        return (
          <JsonViewer>
            {tag_info.map((tag, key) => (
              <Field title={tag.name} key={key}>
                {tag.value}
              </Field>
            ))}
          </JsonViewer>
        )
      }
    }
  },
  {
    field: 'via_policy',
    title: 'Policy',
    template: (row, column) => (
      <ExpanderPoliciesContainer
        identity_uri={null}
        className={styles.policyContainer}
        // need to refactor when the component will be rewrite
        row={{
          ...row,
          original: { ...row.original, policies: row.original.via_policy }
        }}
        //
        column={column}
      />
    )
  },
  {
    field: 'objects',
    title: 'Objects'
  },
  {
    field: 'actions',
    title: 'Actions',
    hide: selectedType !== ResourceTypeEnum.OBJECT_STORE
  }
]

export { getColumns }
